import React from 'react';
import injectSheet from 'react-jss';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Theme as theme } from '@spoiler-alert/ui-library';
import { BreadcrumbsStore } from '../store';

const styles = {
  breadcrumbWrapper: {
    padding: 16,
    fontSize: 16,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      overflow: 'visible',
      marginRight: '-16%',
      zIndex: 1,
      background: 'white',
    },
  },
  breadcrumbSpan: {
    '&:after': {
      content: '" / "',
    },
    '&:last-child': {
      '&>a': {
        color: theme.textColorPrimary,
      },
      '&:after': {
        content: '""',
      },
    },
  },
};

interface BreadcrumbsProps {
  classes: Record<keyof typeof styles, string>;
  breadcrumbsStore: BreadcrumbsStore;
}

function Breadcrumbs({ classes, breadcrumbsStore }: BreadcrumbsProps) {
  return (
    <div className={classes.breadcrumbWrapper}>
      {breadcrumbsStore.breadcrumbs.map((bc) => (
        <span key={bc.url} className={classes.breadcrumbSpan}>
          <Link to={bc.url}>{bc.title}</Link>
        </span>
      ))}
    </div>
  );
}

const ConnectedComponent = inject((store) => store)(observer(Breadcrumbs));
const StyledComponent = injectSheet(styles)(ConnectedComponent);
export default StyledComponent;
